import api from "./api";

export function getPackage() {
  return api.apiCall("GET", `/api/v1/product/tomato/packages/list`);
}

export function getCommission(data) {
  return api.apiCall("POST", `/api/v1/product/28/commission`, data);
}

export function getCondition(data) {
  return api.apiCall("POST", `/api/v1/redeem-code/condition`, data);
}

export function getReward() {
  return api.apiCall("GET", "/api/v1/wallet/reward/balance");
}

export function getCusID(data) {
  return api.apiCall("POST", `/api/v1/product/tomato/customer-id`, data);
}

export function verify(code, data) {
  return api.apiCall("POST", `/api/v1/redeem-code/${code}/verify`, data);
}

export function create(data) {
  return api.apiCall(
    "POST",
    `/api/v1/order/create?callback=${window.location.href}`,
    data
  );
}

export function addToCard(data) {
  return api.apiCall("POST", "/api/v1/order/add-to-cart", data);
}
